import { AnnouncementEditParams } from './../announcement/interface/announcement-edit-params';
import { SessionBaseComponent } from './../../../../shared/components/session.base.component';
import { Component, OnInit, Injector } from '@angular/core';
import { AnnouncementService } from '../../service/announcement.service';
import { LaasOption } from 'src/app/core/models/laas-option';
import { CommonDataService } from 'src/app/core/services/common-data.service';

@Component({
  selector: 'laas-announcement-view',
  templateUrl: './announcement-view.component.html',
  styleUrls: ['./announcement-view.component.scss']
})
export class AnnouncementViewComponent extends SessionBaseComponent implements OnInit {
  announcementData: AnnouncementEditParams | null;
  createUser: string;
  title: string;
  startDate: Date;
  endDate: Date;
  type: string;
  announcementTypeOptions: LaasOption[];
  content: string;
  fileList: any[];

  constructor(injector: Injector, private announcementService: AnnouncementService, private commonDataService: CommonDataService) {
    super(injector);

    this.announcementData = null;
    this.createUser = "";
    this.title = "";
    this.startDate = new Date();
    this.endDate = new Date();
    this.type = "";
    this.announcementTypeOptions = [];
    this.content = "";
    this.fileList = [];
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'ANNOUNCEMENT_TYPE').subscribe({
      next: result => {
        this.announcementTypeOptions = [...result].map((option: any) => {
          return {
            label: `${option.codeKey} - ${option.codeDesc}`,
            value: option.codeKey,
          }
        });
      }
    });

    if (this.routeStateService.getCurrent().data != null) {
      if (this.routeStateService.getCurrent().data.mode == 'editToView') {
        this.announcementData = this.routeStateService.getCurrent().data.announcementData;
        if (this.announcementData != null) {
          this.createUser = this.announcementData.createUser ? this.announcementData.createUser : "";
          this.title = this.announcementData.announcementTitle ? this.announcementData.announcementTitle : "";
          this.startDate = this.announcementData.announcementStartDt ? this.announcementData.announcementStartDt : new Date();
          this.endDate = this.announcementData.announcementEndDt ? this.announcementData.announcementEndDt : new Date();
          this.type = this.announcementData.announcementType ? this.announcementData.announcementType : "";
          this.content = this.announcementData.announcementContent ? this.announcementData.announcementContent : "";
          this.fileList = this.announcementData.editDocumentList ? this.announcementData.editDocumentList : [];
        }
      } else {
        this.announcementService.searchAnnouncementEdit(this.routeStateService.getCurrent().data).subscribe({
          next: (result) => {
            this.announcementData = result;
            this.createUser = result.createUser ? result.createUser : "";
            this.title = result.announcementTitle ? result.announcementTitle : "";
            this.startDate = result.announcementStartDt ? result.announcementStartDt : new Date();
            this.endDate = result.announcementEndDt ? result.announcementEndDt : new Date();
            this.type = result.announcementType ? result.announcementType : "";
            this.content = result.announcementContent ? result.announcementContent : "";
            this.fileList = result.editDocumentList ? result.editDocumentList : [];
          }
        });
      }
    }
  }

  downloadAnnouncementFile(docId: string, name: string, type:string): void {
    this.announcementService.downloadAnnouncementFile(docId, name, type).subscribe(result => {
      var blob = new Blob([result], { type: 'application/octet-stream' }); // application後面接下載的副檔名
      let downloadURL = window.URL.createObjectURL(blob);
      let link = document.createElement('a');
      link.href = downloadURL;
      link.download = `${name}.${type}`;
      link.click();
    });
  }

}
